// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"777":"31d6cfe0","2194":"31d6cfe0","3700":"31d6cfe0","7961":"a3b39f72","9002":"cc885367"}[chunkId] + ".chunk.css";
};